'use client';

import { ClickAwayListener } from '@packages/shared/src/ui/ClickAwayListener/ClickAwayListener';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { type ResponsiveNavigationLayoutProps } from './ResponsiveNavigationLayout';

export type PrimaryNavigationClientWrapperProps = Omit<
  ResponsiveNavigationLayoutProps,
  'button' | 'isLevel2Visible'
>;

export const PrimaryNavigationClientWrapper = ({
  children,
  hamburgerShouldBeMounted,
  hamburgerClassNames,
  onClickAway,
}: PrimaryNavigationClientWrapperProps) => (
  <ClickAwayListener onClickAway={() => onClickAway?.()}>
    <div
      className={cn(
        !hamburgerShouldBeMounted && 'max-lg:hidden max-lg:-translate-x-full',
        hamburgerClassNames,
        "grid [grid-template:'header'_auto_'toggle'_auto_'content'_1fr_'anchor'_0px_/100%]",
        'max-lg:z-drawer max-lg:bg-color-background-base',
        'max-lg:fixed max-lg:inset-0 max-lg:overflow-y-auto max-lg:shadow',
        'max-lg:[&.transition-enter-active]:[transition:transform_ease-in-out_0.3s,opacity_ease-in-out_0.2s]',
        'max-lg:[&.transition-leave-active]:[transition:transform_ease-in-out_0.3s,opacity_ease-in-out_0.2s]',
        'max-lg:[&.transition-enter-from]:-translate-x-full max-lg:[&.transition-leave-to]:-translate-x-full',
        'max-lg:[&.transition-enter-from]:opacity-0 max-lg:[&.transition-leave-to]:opacity-0',
        'motion-reduce:max-lg:[&.transition-enter-active]:transition-none motion-reduce:max-lg:[&.transition-leave-active]:transition-none',
        'lg:relative',
      )}
    >
      {children}
    </div>
  </ClickAwayListener>
);
